export function isSpecialError(error) {
    return "error_type" in error;
}
